<template lang="html">
    <v-snackbar
    :timeout="3000"
    :bottom="true"
    v-model="show"
    >
    {{ text }}
    <v-btn flat color="accent" @click.native="show = false">Close</v-btn>
</v-snackbar>
</template>

<script>
import * as actions from '@/constants/actions';

export default {
    name: 'toast-wrapper',
    computed: {
        show: {
            get() {
                return this.$store.state.toast.show;
            },
            set(val) {
                this.$store.dispatch(actions.SHOW_TOAST, val);
            },
        },
        text() {
            return this.$store.state.toast.text;
        },
    },
};
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/Toast.vue